namespace('IO.Views.HierarchyDefinitions', function (exports) {
  'use strict';
  exports.Index = IO.Views.HierarchyDefinitions.New;
});
